const initialState = {
  data: [],
};
export default (state = initialState, action) => {
  switch (action.type) {
    case 'RETRIEVE_CHARITIES':
      return {
        ...state,
        data: action.data,
      };
    default:
      return state;
  }
};
